var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2634",
    "data-name": "Group 2634",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15886",
    "data-name": "Path 15886",
    d: "M125.37,222.74a12,12,0,1,1,12-12A12.015,12.015,0,0,1,125.37,222.74Zm0-22.857a10.857,10.857,0,1,0,10.858,10.858A10.87,10.87,0,0,0,125.37,199.882Z",
    transform: "translate(-113.37 -198.74)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15887",
    "data-name": "Path 15887",
    d: "M132.555,218.6h2.19v7.028h-2.19Zm1.093-3.49a1.266,1.266,0,1,1-1.268,1.264,1.268,1.268,0,0,1,1.268-1.264",
    transform: "translate(-125.261 -208.878)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15888",
    "data-name": "Path 15888",
    d: "M142.62,224.385h2.1v.962h.029a2.3,2.3,0,0,1,2.07-1.137c2.212,0,2.62,1.454,2.62,3.348v3.855h-2.183V228c0-.816-.015-1.865-1.137-1.865s-1.312.889-1.312,1.8v3.476H142.62Z",
    transform: "translate(-131.59 -214.598)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.c8470c41db5106619268663a20fa198c.svg";
export { ForwardRef as ReactComponent };